<!-- Image Uploader Container -->
<div class="image-uploader-container" [class.minimized]="isMinimized" #modalContainer>
  <!-- Header -->
  <div class="image-uploader-header">
    <div class="header-content">
      <div class="logo">
        <i class="fas fa-image"></i>
        <h1>Upload Image</h1>
      </div>
      <div class="uploader-controls">
        <button class="control-btn" (click)="cancelUpload()" title="Close Uploader">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Form Area -->
  <form class="image-uploader-form" (ngSubmit)="onUpdate()">
    <div class="form-group">
      <label for="currentImage"><i class="fas fa-image"></i> Current Image</label>
      <div class="image-container">
        <img [src]="originalImageSrc" alt="Current image" *ngIf="originalImageSrc" class="current-image-preview">
        <div class="no-image" *ngIf="!originalImageSrc">
          <i class="fas fa-image"></i>
          <span>No image selected</span>
        </div>
        <div class="inline-dimensions" *ngIf="originalImageSrc && currentImageDimensions">
          <i class="fas fa-expand-arrows-alt"></i>
          <span>{{ currentImageDimensions.width }} × {{ currentImageDimensions.height }}</span>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="newImageSrc && newImageSrc !== originalImageSrc">
      <label for="newImage"><i class="fas fa-upload"></i> New Image Preview</label>
      <div class="image-container">
        <img [src]="newImageSrc" alt="New image preview" class="new-image-preview">
      </div>
    </div>

    <div class="form-group">
      <label for="fileInput"><i class="fas fa-cloud-upload-alt"></i> Choose New Image</label>
      <div class="file-input-container">
        <input 
          type="file" 
          id="fileInput" 
          #fileInput
          accept="image/*" 
          (change)="onFileSelected($event)"
          class="file-input">
        <button type="button" class="browse-btn" (click)="fileInput.click()" #browseBtn>
          <i class="fas fa-folder-open"></i> Browse Files
        </button>
      </div>
      <div class="file-info" *ngIf="selectedFile">
        <span>
          <i class="fas fa-file-image"></i>
          <span>{{ selectedFile.name }} ({{ formatFileSize(selectedFile.size) }})</span>
        </span>
        <div class="image-dimensions" *ngIf="imageDimensions">
          <i class="fas fa-expand-arrows-alt"></i>
          <span>{{ imageDimensions.width }} × {{ imageDimensions.height }} pixels</span>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button type="submit" class="btn btn-primary" [disabled]="!selectedFile">Update</button>
      <button type="button" class="btn btn-secondary" (click)="cancelUpload()">Cancel</button>
    </div>
  </form>
</div> 